/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagementEditMemberRequest = {
    id: number;
    lastName: string;
    firstName: string;
    lastKana?: string | null;
    firstKana?: string | null;
    type?: MemberManagementEditMemberRequest.type;
    companyName?: string | null;
    nickname?: string;
    zip?: string | null;
    address1?: string | null;
    address2?: string | null;
    address3?: string | null;
    tel?: string | null;
    telDaytime?: string | null;
    email?: string;
    password?: string;
    language?: MemberManagementEditMemberRequest.language;
    isNewsletter?: boolean;
    isNotice?: boolean;
    status?: MemberManagementEditMemberRequest.status;
    eventNumber?: number;
    statusConfirm?: MemberManagementEditMemberRequest.statusConfirm;
};

export namespace MemberManagementEditMemberRequest {

    export enum type {
        CONSUMER = 'consumer',
        BUSINESS = 'business',
        MANIA = 'mania',
        EVENT = 'event',
    }

    export enum language {
        JP = 'jp',
        EN = 'en',
        CN = 'cn',
    }

    export enum status {
        AVAILABLE = 'available',
        SUSPENSION = 'suspension',
    }

    export enum statusConfirm {
        UNCONFIRMED = 'unconfirmed',
        CONFIRMED = 'confirmed',
    }


}

